import styled from 'styled-components';
import { color } from '~/assets/styles/colors';

export const ContentPerfil = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: center;
	padding: 20px;
`;

export const PerfilText = styled.text`
	font-size: 16px;
	margin-bottom: 16px;
	margin-right: 12px;
`;

// Left

export const ContentLeft = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	margin-right: 100px;
`;

export const ContentPerfilTextLeft = styled.div`
	padding: 20px;
	border-bottom: 1px solid #d7d7d7;

	&:last-child {
		border-bottom: none;
	}
`;

export const FotoPerfil = styled.img`
	width: 250px;
	height: 250px;
	margin: 15px;

	border: 3px solid ${color.yellow};
`;

// Right

export const ContentRight = styled.div`
	display: flex;
	flex-direction: column;

	padding: 20px;
`;

export const ContentPerfilTextRight = styled.div`
	display: flex;
	flex-direction: column;

	padding-bottom: 50px;
	padding-top: 30px;
`;

export const H3Right = styled.h3`
	display: flex;
	// Definindo um tamanho de fonte com vh, vamos escalar segundo a largura do viewport
	width: 70vh;

	border-bottom: 1px solid #d7d7d7;
`;

export const ButtonDiv = styled.div`
	display: flex;
	position: absolute;

	left: 657px;
	top: 265px;
`;

export const ButtonStyle = styled.button`
	background-color: ${color.yellow};
	height: 60px;
	width: 60px;
	border: 0;
	border-radius: 50px;
`;

export const FormDiv = styled.div`
	display: flex;
	flex-direction: row;
`;
